/**
 * NO SE OFRECE MANTENIMIENTO A QUIEN YA ESTÁ EN MANTENIMIENTO (14-10, CAD-02 y BAJ-04).
 *
 * Mantenimiento es donde aterriza quien no renueva. Dos pantallas se lo proponían a todo el
 * mundo sin mirar su plan: Inicio con el plan vencido («¿Prefieres seguir por tu cuenta?
 * Mantenimiento son 60 €/mes...») y el motivo «Es caro» de «No quiero renovar» («Pasarme a
 * Mantenimiento», que lleva a pagar). A quien ya lo tiene se le proponía pagar otra vez lo
 * suyo. La regla vive aquí y las dos pantallas dependen de ella.
 *
 * Qué plan es «la salida» lo dice el catálogo (`solo_salida`), no su nombre: es lo mismo que
 * mira el servidor al cobrar y el cuestionario al montar sus pasos. La pantalla de renovación
 * no pasa por aquí: sus tarjetas las decide el servidor (`core/renovacion.salidas`).
 */

/** ¿Se le puede proponer el plan de salida? No a quien ya está en él. `suPlan` es la ficha de
 *  su plan en el catálogo (`myPlan` del contexto, o `planCatalog[profile.plan]`). */
export function seLeOfreceMantenimiento(suPlan) {
    return !suPlan?.solo_salida;
}

/**
 * ¿El motivo de «No quiero renovar» trae una alternativa antes de la baja? «Es caro» trae
 * Mantenimiento (salvo a quien ya está en él), «No tengo tiempo» aplazar y «No estoy viendo
 * resultados» la revisión. «Otra cosa» no trae ninguna: es texto libre. Sin alternativa, el
 * botón de abajo es directamente «Confirmar la baja».
 */
export function elMotivoTraeAlternativa(motivo, suPlan) {
    if (!motivo || motivo === 'otra') return false;
    if (motivo === 'caro') return seLeOfreceMantenimiento(suPlan);
    return true;
}
